import { useState } from 'react';
import { COUNTRY_PATHS } from './exYuMapData';
import { useLang } from '../contexts/LanguageContext';

const COUNTRIES = [
  { id: 'slovenia', nameKey: 'country_slovenia', flagColors: ['#FFFFFF', '#0051A5', '#ED1C24'] },
  { id: 'croatia', nameKey: 'country_croatia', flagColors: ['#FF0000', '#FFFFFF', '#171796'] },
  { id: 'bosnia', nameKey: 'country_bosnia', flagColors: ['#002395', '#FECA00', '#FFFFFF'] },
  { id: 'serbia', nameKey: 'country_serbia', flagColors: ['#C6363C', '#0C4076', '#FFFFFF'] },
  { id: 'montenegro', nameKey: 'country_montenegro', flagColors: ['#C8102E', '#D4AF37', '#FFFFFF'] },
  { id: 'kosovo', nameKey: 'country_kosovo', flagColors: ['#244AA5', '#D4AF37', '#FFFFFF'] },
  { id: 'north_macedonia', nameKey: 'country_north_macedonia', flagColors: ['#CE2028', '#F9D616', '#CE2028'] },
];

export default function ExYuMap({ onSelect, selected }) {
  const [hovered, setHovered] = useState(null);
  const { t } = useLang();

  return (
    <div className="relative w-full max-w-[650px] mx-auto">
      <svg viewBox="0 0 800 520" className="w-full h-auto" style={{ filter: 'drop-shadow(0 0 20px rgba(212,175,55,0.15))' }}>
        <defs>
          {COUNTRIES.map(c => (
            <linearGradient key={`flag-${c.id}`} id={`flag-${c.id}`} x1="0%" y1="0%" x2="0%" y2="100%">
              {c.flagColors.map((color, i) => (
                <stop key={i} offset={`${(i / (c.flagColors.length - 1)) * 100}%`} stopColor={color} />
              ))}
            </linearGradient>
          ))}
          {/* Dimmed (but solid) flag gradients for default state - slightly darker overlay via opacity attr on path */}
          {COUNTRIES.map(c => (
            <linearGradient key={`flag-dim-${c.id}`} id={`flag-dim-${c.id}`} x1="0%" y1="0%" x2="0%" y2="100%">
              {c.flagColors.map((color, i) => (
                <stop key={i} offset={`${(i / (c.flagColors.length - 1)) * 100}%`} stopColor={color} />
              ))}
            </linearGradient>
          ))}
        </defs>

        {COUNTRIES.map(country => {
          const mapData = COUNTRY_PATHS[country.id];
          if (!mapData) return null;
          const isSelected = selected === country.id;
          const isHovered = hovered === country.id;

          const fill = isSelected
            ? `url(#flag-${country.id})`
            : isHovered
              ? `url(#flag-${country.id})`
              : `url(#flag-dim-${country.id})`;

          return (
            <g key={country.id}>
              <path
                d={mapData.path}
                fill={fill}
                stroke={isSelected ? '#F0C84A' : '#D4AF37'}
                strokeWidth={isSelected ? 2.5 : isHovered ? 2 : 1}
                className={`cursor-pointer transition-all duration-300 ${(isHovered || isSelected) ? 'country-pulse' : ''}`}
                style={{
                  opacity: 1
                }}
                onClick={() => onSelect(country.id)}
                onMouseEnter={() => setHovered(country.id)}
                onMouseLeave={() => setHovered(null)}
                data-testid={`map-country-${country.id}`}
              />
              {(isHovered || isSelected) && (
                <path
                  d={mapData.path}
                  fill="none"
                  stroke="#F0C84A"
                  strokeWidth="1.5"
                  className="country-ripple pointer-events-none"
                  style={{ mixBlendMode: 'screen' }}
                />
              )}
              <text
                x={mapData.labelX}
                y={mapData.labelY}
                textAnchor="middle"
                fill={isSelected || isHovered ? '#F0C84A' : '#FFFFFF'}
                fontSize="14"
                fontFamily="Outfit, sans-serif"
                fontWeight={isSelected ? '700' : '500'}
                className="pointer-events-none select-none"
                style={{ transition: 'all 0.3s ease', textShadow: '0 1px 6px rgba(0,0,0,0.9)' }}
              >
                {t(country.nameKey)}
              </text>
            </g>
          );
        })}
      </svg>

      {selected && (
        <div className="text-center mt-4">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4AF37]">
            {t('selected_heritage')}
          </span>
          <p className="text-white text-lg font-medium mt-1 font-['Outfit']">
            {t(COUNTRIES.find(c => c.id === selected)?.nameKey || '')}
          </p>
        </div>
      )}
    </div>
  );
}
